import { usePWAInstallContext } from '../contexts/PWAInstallContext';

export interface UsePWAInstallResult {
  canInstall: boolean;
  isStandalone: boolean;
  promptInstall: () => Promise<boolean>;
}

export function usePWAInstall(): UsePWAInstallResult {
  const ctx = usePWAInstallContext();

  if (ctx) {
    return {
      canInstall: ctx.canInstall,
      isStandalone: ctx.isStandalone,
      promptInstall: ctx.promptInstall,
    };
  }

  return {
    canInstall: false,
    /** Senza provider non si può sapere se standalone: false evita di bloccare "Scarica App" come già installata. */
    isStandalone: false,
    promptInstall: async () => false,
  };
}
